// Meta Pixel (browser) + Conversions API relay. Nothing loads or is sent until
// the member accepts the cookie banner. Needs REACT_APP_META_PIXEL_ID.
import * as api from './api';
import posthog from './posthog';

export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = 'sirati_cookie_consent'; // 'granted' | 'denied'
const CONSENT_EVENT = 'sirati-consent-changed';

export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

const notify = () => window.dispatchEvent(new Event(CONSENT_EVENT));
export const onConsentChange = (fn) => {
  window.addEventListener(CONSENT_EVENT, fn);
  return () => window.removeEventListener(CONSENT_EVENT, fn);
};

const applyPosthog = (granted) => {
  try { granted ? posthog.opt_in_capturing() : posthog.opt_out_capturing(); } catch { /* analytics not initialised */ }
};

export const setConsent = (value) => {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* private mode: choice lasts this visit only */ }
  applyPosthog(value === 'granted');
  if (value === 'denied' && window.fbq) window.fbq('consent', 'revoke');
  notify();
};

// Lets a member reopen the banner (Privacy page link).
export const resetConsent = () => {
  try { localStorage.removeItem(CONSENT_KEY); } catch { /* ignore */ }
  notify();
};

let loaded = false;
const ensurePixel = () => {
  if (loaded) return true;
  if (!PIXEL_ID || getConsent() !== 'granted') return false;
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  loaded = true;
  return true;
};

const cookie = (name) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : undefined;
};

export const trackPageView = () => {
  if (ensurePixel()) window.fbq('track', 'PageView');
};

const PLAN_VALUES = { monthly: 7, yearly: 70, lifetime: 97 };

// Fires the Pixel event and relays the same event (same event_id) to our server
// for the Conversions API, so Meta counts it once.
export const trackEvent = (name, { plan, eventId } = {}) => {
  if (!ensurePixel()) return false;
  const id = eventId || (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${name}_${Date.now()}`);
  const custom = plan ? { currency: 'USD', value: PLAN_VALUES[plan], content_name: `Sirati+ ${plan}` } : {};
  window.fbq('track', name, custom, { eventID: id });
  api.relayMetaEvent({
    event_name: name,
    event_id: id,
    event_source_url: window.location.href,
    plan,
    fbp: cookie('_fbp'),
    fbc: cookie('_fbc'),
  }).catch(() => { /* measurement must never break the app */ });
  return true;
};

// For events that should only ever fire once per member (e.g. registration).
export const trackOnce = (storageKey, name, opts) => {
  try { if (localStorage.getItem(storageKey)) return; } catch { /* fall through */ }
  if (trackEvent(name, opts)) {
    try { localStorage.setItem(storageKey, '1'); } catch { /* ignore */ }
  }
};
